<template>
  <div>
    <Dialog
      :key="dialogKey"
      :visible.sync="mergeDialog1"
      :style="{ width: '60%', overflowY: 'auto' }"
      header="Merge Customer Dialog"
      :modal="true"
      class="p-fluid"
    >
      <div
        class="p-formgrid p-grid"
        :style="{
          height:
            mergeWithCustomer && mergeWithCustomer.customerId
              ? '100px'
              : '227px'
        }"
      >
        <div class="p-field p-col">
          <CustomDropDown
            :allOptions="customerNames"
            :disabled="false"
            optionLabel="custName"
            dataKey="customerId"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="mergeWithCustomer"
            placeholder="Select Customer"
            style="width: 100%"
            @selected="setSelection"
            :inputClass="{
              'p-invalid':
                submitted &&
                !(mergeWithCustomer && mergeWithCustomer.customerId)
            }"
            :showIds="true"
          />
          <small
            class="p-invalid"
            v-if="
              submitted && !(mergeWithCustomer && mergeWithCustomer.customerId)
            "
            >Customer is required.</small
          >
        </div>
      </div>
      <div
        class="p-formgrid p-grid"
        v-if="mergeWithCustomer && mergeWithCustomer.customerId"
      >
        <div class="p-field p-col">
          <p>
            This function will move all related records for customer:
            {{ customer.custName }} ({{ customer.branchCode }})({{
              customer.customerId
            }}) to the customer: {{ mergeWithCustomer.custName }} ({{
              mergeWithCustomer.branchCode
            }}) ({{ mergeWithCustomer.customerId }})
          </p>
          <p>
            This will move, CONTACTS, ATTACHMENTS, NOTES, ENQUIRIES, QUOTATIONS
            AND WILL LINK EXISTING MBP BRANCHES used by
            {{ customer.custName }} ({{ customer.customerId }}) to
            {{ mergeWithCustomer.custName }} ({{
              mergeWithCustomer.customerId
            }})
          </p>
          <p>
            Please delete any CONTACTS for {{ customer.custName }} ({{
              customer.customerId
            }}) before running this function otherwise you may have duplication
            with contacts from {{ mergeWithCustomer.custName }} ({{
              mergeWithCustomer.customerId
            }})
          </p>
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          @click="$emit('close')"
          class="p-button-danger"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Merge"
          icon="pi pi-check"
          @click="mergeCustomer()"
          autofocus
          :disabled="!(mergeWithCustomer && mergeWithCustomer.customerId)"
        />
        <br />
        <p
          style="color: red;"
          v-if="mergeWithCustomer && mergeWithCustomer.customerId"
        >
          This action can not be reversed, please ensure you have selected the
          right customers.
        </p>
      </template>
    </Dialog>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

export default {
  updated() {
    this.setFocus();
  },
  props: {
    mergeDialog: {
      type: Boolean,
      required: true
    },
    reloadDialog: {
      type: Number,
      required: false
    },
    customerNames: {
      type: Array,
      required: true
    },
    customer: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    customerService: new CustomerService(),
    dialogKey1: 0,
    mergeWithCustomer: {},
    submitted: false,
    sendingRequest: false
  }),
  computed: {
    dialogKey: {
      set() {
        this.dialogKey1++;
      },
      get() {
        return "dialogKey-" + this.dialogKey1.toString();
      }
    },
    mergeDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.mergeDialog;
      }
    }
  },
  watch: {
    reloadDialog() {
      this.mergeWithCustomer = {};
      this.dialogKey++;
      this.setFocus();
    }
  },
  methods: {
    mergeCustomer() {
      if (
        this.customer &&
        this.customer.customerId &&
        this.mergeWithCustomer &&
        this.mergeWithCustomer.customerId
      ) {
        this.sendingRequest = true;

        this.customerService
          .mergeCustomer(
            this.customer.customerId,
            this.mergeWithCustomer.customerId
          )
          .then(data => {
            this.sendingRequest = false;

            this.$toast.add({
              severity: "success",
              summary: "Successfull",
              detail: "Customer merged successfully.",
              life: 5000
            });

            this.$emit("success");
          })
          .catch(error => {
            this.sendingRequest = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while merging customer",
              life: 5000
            });
          });
      }
    },
    setFocus() {
      let a = document.getElementById("customDropdownInput");
      if (a) {
        a.focus();
      }
    },
    setSelection({ value, index }) {
      //
      this.mergeWithCustomer = value;
    }
  }
};
</script>

<style></style>
